import { useLocation } from "react-router";

/**
 * TODO: path pattern without circular reference
 * on the route config object.
 */
export function useRoutePathPattern(): string {
  const location = useLocation();

  return location.pathname;
}
